import React, { useState } from 'react';
import { Button, Col, Form, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';

const scoreValues = {
  edad: [
    '18-35',
    '36-45',
    '46-60',
    'Más de 60'
  ],
  personasACargo: [
    '0',
    '1',
    '2',
    '3 o más'
  ],
  hijos: [
    '0',
    '1',
    '2',
    '3 o más'
  ],
  edadPromedioHijos: [
    'Menos de 10',
    '11-15',
    '16-20',
    '21-35',
    'Más de 35'
  ],
  necesarioEstudiarOTrabajar: [
    'Si',
    'No'
  ],
  alDiaServiciosArriendo: [
    'Si',
    'No'
  ],
  situacionLaboral: [
    'Trabajando',
    'Licencia no remunerada'
  ],
  nucleoFamiliarTrabajo: [
    '0',
    '1',
    '2',
    'Más de 3'
  ]
};

const select = state => {
  return {
    token: state.auth.token,
    userId: state.auth.userId
  };
};

function ConnectedScore(props) {

  const [creating, setCreating] = useState(false);
  const [validated, setValidated] = useState(false);
  const [edad, setEdad] = useState(scoreValues.edad[0]);
  const [personasACargo, setPersonasACargo] = useState(scoreValues.personasACargo[0]);
  const [hijos, setHijos] = useState(scoreValues.hijos[0]);
  const [edadPromedioHijos, setEdadPromedioHijos] = useState(scoreValues.edadPromedioHijos[0]);
  const [necesarioEstudiarOTrabajar, setNecesarioEstudiarOTrabajar] = useState(scoreValues.necesarioEstudiarOTrabajar[0]);
  const [alDiaServiciosArriendo, setAlDiaServiciosArriendo] = useState(scoreValues.alDiaServiciosArriendo[0]);
  const [situacionLaboral, setSituacionLaboral] = useState(scoreValues.situacionLaboral[0]);
  const [nucleoFamiliarTrabajo, setNucleoFamiliarTrabajo] = useState(scoreValues.nucleoFamiliarTrabajo[0]);

  const handleSubmit = async event => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity()) {

      setCreating(true);

      const values = {
        edad,
        personasACargo,
        hijos,
        necesarioEstudiarOTrabajar,
        alDiaServiciosArriendo,
        situacionLaboral,
        nucleoFamiliarTrabajo
      };

      if (hijos !== '0') values.edadPromedioHijos = edadPromedioHijos;

      const scoreProm = await fetch(`${apiUrl}/users/score`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: props.token,
          userId: props.userId,
          businessName,
          values
        })
      });

      const scoreJson = await scoreProm.json();

      if (scoreJson.success) {
        if (props.successCallback) props.successCallback();
      } else {
        alert(scoreJson.message || 'Error. Inténtalo de nuevo.');
      }

      setCreating(false);
    }
  };

  const mapOptions = arr => {
    return arr.map(item => <option key={item} value={item}>{item}</option>);
  };

  return (
    <div className="score-component">
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Row>

          <Form.Group as={Col} md={4}>
            <Form.Label className="app-label">Edad</Form.Label>
            <Form.Control
              as="select"
              value={edad}
              onChange={event => setEdad(event.target.value)}
              required
            >
              {
                mapOptions(scoreValues.edad)
              }
            </Form.Control>
          </Form.Group>

          <Form.Group as={Col} md={4}>
            <Form.Label className="app-label">Personas a cargo</Form.Label>
            <Form.Control
              as="select"
              value={personasACargo}
              onChange={event => setPersonasACargo(event.target.value)}
              required
            >
              {
                mapOptions(scoreValues.personasACargo)
              }
            </Form.Control>
          </Form.Group>

          <Form.Group as={Col} md={4}>
            <Form.Label className="app-label">Hijos</Form.Label>
            <Form.Control
              as="select"
              value={hijos}
              onChange={event => setHijos(event.target.value)}
              required
            >
              {
                mapOptions(scoreValues.hijos)
              }
            </Form.Control>
          </Form.Group>
          {
            hijos !== '0' &&
            <Form.Group as={Col} md={6}>
              <Form.Label className="app-label">Edad promedio de los hijos</Form.Label>
              <Form.Control
                as="select"
                value={edadPromedioHijos}
                onChange={event => setEdadPromedioHijos(event.target.value)}
                required
                >
                {
                  mapOptions(scoreValues.edadPromedioHijos)
                }
              </Form.Control>
            </Form.Group>
          }
          <Form.Group as={Col} md={6}>
            <Form.Label className="app-label">Tienen lo necesario para estudiar o trabajar</Form.Label>
            <Form.Control
              as="select"
              value={necesarioEstudiarOTrabajar}
              onChange={event => setNecesarioEstudiarOTrabajar(event.target.value)}
              required
            >
              {
                mapOptions(scoreValues.necesarioEstudiarOTrabajar)
              }
            </Form.Control>
          </Form.Group>

          <Form.Group as={Col} md={6}>
            <Form.Label className="app-label">Al día con los servicios/arriendo</Form.Label>
            <Form.Control
              as="select"
              value={alDiaServiciosArriendo}
              onChange={event => setAlDiaServiciosArriendo(event.target.value)}
              required
            >
              {
                mapOptions(scoreValues.alDiaServiciosArriendo)
              }
            </Form.Control>
          </Form.Group>

          <Form.Group as={Col} md={6}>
            <Form.Label className="app-label">Situación laboral</Form.Label>
            <Form.Control
              as="select"
              value={situacionLaboral}
              onChange={event => setSituacionLaboral(event.target.value)}
              required
            >
              {
                mapOptions(scoreValues.situacionLaboral)
              }
            </Form.Control>
          </Form.Group>

          <Form.Group as={Col} md={6}>
            <Form.Label className="app-label">Cuantas personas tienen trabajo en tu nucleo familiar a parte de ti</Form.Label>
            <Form.Control
              as="select"
              value={nucleoFamiliarTrabajo}
              onChange={event => setNucleoFamiliarTrabajo(event.target.value)}
              required
            >
              {
                mapOptions(scoreValues.nucleoFamiliarTrabajo)
              }
            </Form.Control>
          </Form.Group>

          <Col xs={12}>
            <Button className="app-button" type="submit" disabled={creating}>
              {
                creating ? <Spinner variant="warning" size="sm" animation="border" /> :
                'Confirmar'
              }
            </Button>
          </Col>

        </Form.Row>
      </Form>
    </div>
  );
}

const Score = connect(select)(ConnectedScore);

export default Score;
